import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/property';

const namespace = 'MOBILE';

export const GET_PROPERTY_CHANGES_START = `${namespace}/GET_PROPERTY_CHANGES_START`;
export const GET_PROPERTY_CHANGES_SUCCESS = `${namespace}/GET_PROPERTY_CHANGES_SUCCESS`;
export const GET_PROPERTY_CHANGES_ERROR = `${namespace}/GET_PROPERTY_CHANGES_ERROR`;

export const APPROVE_PROPERTY_CHANGES_START = `${namespace}/APPROVE_PROPERTY_CHANGES_START`;
export const APPROVE_PROPERTY_CHANGES_SUCCESS = `${namespace}/APPROVE_PROPERTY_CHANGES_SUCCESS`;
export const APPROVE_PROPERTY_CHANGES_ERROR = `${namespace}/APPROVE_PROPERTY_CHANGES_ERROR`;

export const REJECT_PROPERTY_CHANGES_START = `${namespace}/REJECT_PROPERTY_CHANGES_START`;
export const REJECT_PROPERTY_CHANGES_SUCCESS = `${namespace}/REJECT_PROPERTY_CHANGES_SUCCESS`;
export const REJECT_PROPERTY_CHANGES_ERROR = `${namespace}/REJECT_PROPERTY_CHANGES_ERROR`;

export const SET_PROPERTY_CHANGE_MAIN_IMAGE_START = `${namespace}/SET_PROPERTY_CHANGE_MAIN_IMAGE_START`;
export const SET_PROPERTY_CHANGE_MAIN_IMAGE_SUCCESS = `${namespace}/SET_PROPERTY_CHANGE_MAIN_IMAGE_SUCCESS`;
export const SET_PROPERTY_CHANGE_MAIN_IMAGE_ERROR = `${namespace}/SET_PROPERTY_CHANGE_MAIN_IMAGE_ERROR`;

export const SEARCH_PROPERTY_START = `${namespace}/SEARCH_PROPERTY_START`;
export const SEARCH_PROPERTY_SUCCESS = `${namespace}/SEARCH_PROPERTY_SUCCESS`;
export const SEARCH_PROPERTY_ERROR = `${namespace}/SEARCH_PROPERTY_ERROR`;

export const SET_SEARCH_FORM_DATA = `${namespace}/SET_SEARCH_FORM_DATA`;
export const setFormData = formData => ({
  type: SET_SEARCH_FORM_DATA,
  payload: formData,
});

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const searchProperty = makeApiActionCreatorV3(
  api.searchProperty,
  SEARCH_PROPERTY_START,
  SEARCH_PROPERTY_SUCCESS,
  SEARCH_PROPERTY_ERROR,
);

export const getPropertyChanges = makeApiActionCreatorV3(
  api.getPropertyChanges,
  GET_PROPERTY_CHANGES_START,
  GET_PROPERTY_CHANGES_SUCCESS,
  GET_PROPERTY_CHANGES_ERROR,
);

export const approvePropertyChanges = makeApiActionCreatorV3(
  api.approvePropertyChanges,
  APPROVE_PROPERTY_CHANGES_START,
  APPROVE_PROPERTY_CHANGES_SUCCESS,
  APPROVE_PROPERTY_CHANGES_ERROR,
);

export const rejectPropertyChanges = makeApiActionCreatorV3(
  api.rejectPropertyChanges,
  REJECT_PROPERTY_CHANGES_START,
  REJECT_PROPERTY_CHANGES_SUCCESS,
  REJECT_PROPERTY_CHANGES_ERROR,
);

export const setPropertyChangeMainImage = makeApiActionCreatorV3(
  api.setPropertyChangeMainImage,
  SET_PROPERTY_CHANGE_MAIN_IMAGE_START,
  SET_PROPERTY_CHANGE_MAIN_IMAGE_SUCCESS,
  SET_PROPERTY_CHANGE_MAIN_IMAGE_ERROR,
);
